export default __webpack_public_path__ + "static/media/copyIcon copy.9d66be0b.svg";